export const APP_NAME = 'International Data Portal';
export const MARKET_FAN_EXPLORATION = 'Market Fan Exploration';
